import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import "@styles/opencart-admin.css";
import "@lib/diagnostics"; // start capturing console/JS errors as early as possible


import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from '@redux/store';

import App from './App';
import "./AdminNoteMode"; // self-mounting Notes/Tickets overlay (admin tickets → /notes).


const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>

);

reportWebVitals();
